import React, { Component, useHistory } from 'react';
import './ForgetPassword.css';
import axios from 'axios';

import Spinner from '../MerchandiseStore/Spinner/Spinner';
import mailSentImg from '../../assets/img/mailSent.jpeg'
import {FiChevronLeft} from 'react-icons/fi';
import resetPasswordImg from '../../assets/img/forgotPassword.jpg';
import Header from '../../components/partials/HeaderComponent';
import Footer from '../../components/partials/FooterComponent';

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

class ForgetPassword extends Component {

    state = {
        email: "",
        error: false,
        errorMessage: "Invalid email address",
        mailSent: false,
        loading: false
    }

    componentDidMount() {
        localStorage.removeItem("Codeium__Username")
    }

    changeEmailHandler = (event) => {
        const email = event.target.value;
        if(validateEmail(email)) {
            this.setState({
                error: false
            })
        }
        this.setState({
            email: email
        })
    }

    formSubmitHandler = async (event) => {
        
        event.preventDefault();
        if(!validateEmail(this.state.email)) {
            this.setState({
                error: true
            })
        } else
        {
            this.setState({
                loading: true
            })
            await axios.post('https://server.codeium.tech/forgot/password/mail', {
                email_id: this.state.email,
                username: ""
            }).then(res => {
                // console.log(res);
                if(res.data.status === 415) {
                    this.setState({
                        error: true,
                        errorMessage: "User not found"
                    })
                } else if(res.data.status === 420) {
                    this.setState({
                        error: true,
                        errorMessage: "Some error Occurred. Please try again later"
                    })
                } else {
                    this.setState({
                        mailSent: true
                    })
                }
            }).catch(err => {
                // console.log(err);
            })

            this.setState({
                loading: false
            })
        }
    }

    resendHandler = () => {
        window.location.reload();
    }

    render()
    {
        return (
            <>
                <Header />
                {
                    this.state.loading ? <Spinner /> : (
                        <div className="container my-5">
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center">
                                    <div className="CustomCard1 d-flex flex-column align-items-center">
                                        {
                                            this.state.mailSent ? (
                                                <div>
                                                    <div className="ImgContainer2">
                                                        <img src={mailSentImg} />
                                                    </div>
                                                    <h3 className="text-center text-bold">Email has been Sent!</h3>
                                                    <p className="text-center px-3 my-3">Please check your inbox and click in the received link to reset your password</p>
                                                    <p className="mt-4 text-center text-muted">Didn't received the link? <span className="text-danger Resend_Button" onClick={this.resendHandler}>Resend</span></p>
                                                </div>
                                            ) : (
                                            <>
                                                <div className="ImgContainer">
                                                    <img src={resetPasswordImg} />
                                                </div>
                                                <h5><b>Forgot Password</b></h5>
                                                <p className="text-muted text-center line-height-1rem mt-2" >Enter your email below and we will send you a link to reset your password</p>
                                                <form onSubmit={this.formSubmitHandler} className="mt-4 d-block ForgotPasswordForm">
                                                    <div class="form-group">
                                                        <input value={this.state.email} onChange={this.changeEmailHandler} type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your email" />
                                                        {
                                                            this.state.error ? (
                                                                <div class="invalid-feedback">
                                                                    {this.state.errorMessage}
                                                                </div>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <button type="submit" className="btn btn-info btn-block mt-4 mb-2">
                                                        Submit
                                                    </button>
                                                </form>
                                                <a href="/">
                                                    <button className="btn BackLogin mt-1 mb-4"> 
                                                        <FiChevronLeft style={{fontSize: '18px', fontWeight: 'bold'}} className="mb-1"/>Back to Login
                                                    </button>
                                                </a>
                                            </>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                <Footer />
            </>
        )
    }
}

export default ForgetPassword;